import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import withReduxProvider from "web/react/redux-provider";
import SecondaryButton from "web/react/components/buttons/secondary-button/secondary-button";
import CookieSettingsContainer from "web/react/components/cookie-settings-container/cookie-settings-container";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { consentToAllCookies } from "web/redux/ducks/cookie-consent";
import history from "web/script/utils/history";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import environment from "web/script/modules/environment";
import styles from "./cookie-banner.css";

function extractConsentState(state) {
    return state.cookieConsentReducer.consentConfirmed;
}

export function CookieBanner({ cookiePolicyUrl, debug }) {
    const cookieConsentRequired = environment.getFeature("mg_require_cookie_consent");
    let [showBanner, setShowBanner] = useState(false);
    const consentConfirmed = useReduxSelector(extractConsentState);
    const dispatch = useDispatch();

    function hideNotification() {
        setShowBanner(false);
        dispatch(consentToAllCookies());
        analytics.event("Cookie consent", "Clicked", "Hide");
    }

    useEffect(() => {
        if (debug || !consentConfirmed) {
            analytics.event("Cookie consent", "Shown", null, true);
            setShowBanner(true);
        } else {
            setShowBanner(false);
        }
    }, [debug, consentConfirmed]);

    let cookieText = gettext("cookie_notification.description_v2");

    const cookieSettingsModal = "cookie-settings-banner-modal";
    const settingsModalIsOpen = !!useOverlayWatcher(cookieSettingsModal);

    function onSettingsModalClose() {
        history.popOverlay(cookieSettingsModal);
    }

    function openSettingsModal() {
        // I check the current overlay state instead of modalIsOpen
        // to get around the delay introduced by hooks
        if (history.getCurrentState().overlay != cookieSettingsModal) {
            history.pushOverlay(cookieSettingsModal);
        }
    }

    return (
        <React.Fragment>
            {showBanner && (
                <div className={styles.wrapper}>
                    <div className={styles.container}>
                        <div className={styles.content}>
                            <p className={styles.text}>
                                {cookieText}{" "}
                                <a className={styles.readMore} href={cookiePolicyUrl}>
                                    {gettext("general.read_more")}
                                </a>
                            </p>
                        </div>
                        <div className={styles.options}>
                            {cookieConsentRequired && (
                                <div className={styles.cookieSettingsWrapper}>
                                    <CookieSettingsContainer
                                        isOpen={settingsModalIsOpen}
                                        onModalClose={onSettingsModalClose}
                                    />
                                    <a className={styles.link} onClick={openSettingsModal}>
                                        {// "Cookie Settings"
                                        gettext("cookie_notification.cookie_settings.title")}
                                    </a>
                                </div>
                            )}
                            <div onClick={hideNotification} className={styles.closeButton}>
                                <SecondaryButton fullHeight fullWidth>
                                    {gettext("general.accept")}
                                </SecondaryButton>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

CookieBanner.defaultProps = {
    // Force the banner to be visible for development.
    debug: false,
};
CookieBanner.propTypes = {
    cookiePolicyUrl: PropTypes.string.isRequired,
    debug: PropTypes.bool,
};
export default withReduxProvider(CookieBanner);
